import { render, staticRenderFns } from "./MessageOverlay.vue?vue&type=template&id=412e2f9d&scoped=true&"
import script from "./MessageOverlay.vue?vue&type=script&lang=ts&"
export * from "./MessageOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./MessageOverlay.vue?vue&type=style&index=0&id=412e2f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e2f9d",
  null
  
)

export default component.exports